<template>
  <span
    class="material-symbols-rounded"
    :class="[
      color ? `text-${color}` : 'text-zinc-300',
      iconClass,
      !noHover && !disabled ? 'cursor-pointer' : 'cursor-default',
      disabled ? 'cursor-not-allowed' : '',
      blend ? 'mix-blend-multiply' : '',
    ]"
  >
    {{ icon }}
  </span>
</template>

<script lang="ts" setup>
type Props = {
  blend?: boolean
  color?: string
  icon: string
  iconClass?: string
  noHover?: boolean
  disabled?: boolean
}
withDefaults(defineProps<Props>(), {
  blend: true,
})
</script>
